
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getServiceList } from '@/api/service';

import DeptDialog from '@/components/DeptDialog/index.vue';
import DeptLevel from '@/components/DeptLev/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';

@Component({
  name: 'orderSearch',
  components: {
    DeptDialog,
    DeptLevel,
    FaultDialog
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private servicerOptions = [];
  private params: object = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
  }
  private taskStatusOptions = [
    // { value: '1', label: '待寄出' }
  // { value: '2', label: '已寄出' },
  // { value: '3', label: '已收货' },
  // { value: '4', label: '已寄回' }
    { value: '29', label: '未完成' },
    { value: '24', label: '已完成' },
    { value: '1', label: '待寄出' }
  ];
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private deptTypeCustomer = 1
  private departmentVisible = false
  private faultVisible= false

  private serverCompanyId = ''
  created() {
    this.serverCompanyId = UserModule.getCompanyId;
  }

  private servicerFocus() {
    getServiceList(this.params).then(res => {
      if (res && res.data) {
        this.servicerOptions = res.data.list;
      }
    });
  }

  private selectedDeptCustomer() {
    this.departmentVisible = true;
  }
  private departmentClose(value: any) {
    this.departmentVisible = value;
  }
  private departmentSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.dept_id;
    this.changeData();
  }

  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private faultSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }

  private clearFault() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }


  private cusDeptType = 9;
  private cusDeptIsMulti = 1;
  private cusDeptHasSub = false;
  private dialogDeptLevelVisible = false;
  private selcetedDeptLevel: any = null;
  private tmpSelcetedDeptLevel: any = null;

  private showDialogDeptLevel() {
    this.dialogDeptLevelVisible = true;
    if( !(this.searchData.fields && this.searchData.fields.name && this.searchData.fields.name.length>0) ){
      this.selcetedDeptLevel =null;
    }
    this.tmpSelcetedDeptLevel = this.selcetedDeptLevel ? [...this.selcetedDeptLevel] : null;
  }

  private handleChangeDeptLevel(value: any) {
    this.tmpSelcetedDeptLevel = value;
  }

  private clearDialogDeptLevel() {
    this.selcetedDeptLevel =  null;
    this.tmpSelcetedDeptLevel = null;
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.searchData.fields.hasSubCustomerDept = false;
    this.changeData();
  }

  private handleChangeCusDeptHasSub(value: boolean) {
    this.searchData.fields.hasSubCustomerDept = value;
    this.changeData();
  }

  private handleConfirmDialogDeptLevel() {
    this.selcetedDeptLevel = this.tmpSelcetedDeptLevel ? [...this.tmpSelcetedDeptLevel] : null;
    this.dialogDeptLevelVisible = false;
    let deptIds = '';
    let deptNames = '';
    if (this.selcetedDeptLevel && this.selcetedDeptLevel.length > 0) {
      this.selcetedDeptLevel.forEach((item: any) => {
        deptIds += item.dept_id + ',';
        deptNames += item.name + ',';
      });
      deptIds = deptIds.substring(0, deptIds.length - 1);
      deptNames = deptNames.substring(0, deptNames.length - 1);
    }
    this.searchData.fields = {};
    this.searchData.fields.name = deptNames;
    this.searchData.fields.id = deptIds;
    this.searchData.fields.hasSubCustomerDept = this.cusDeptHasSub;
    this.changeData();
  }

  private handleCancelDialogDeptLevel() {
    this.tmpSelcetedDeptLevel = null;
    this.dialogDeptLevelVisible = false;
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
